import { Component, OnInit, OnDestroy, ViewChild, NgZone, Injectable } from '@angular/core';
import { IonContent, AlertController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';

// import { Events } from '@ionic/angular';  // deprecated in Ionic 5
import { Events } from 'src/app/services/events/events.service';  // workaround for events

// need to route to another page programmatically
import { Router } from '@angular/router';  // forward to another page
import { ActivatedRoute } from '@angular/router';  // coming to this page from elsewhere

//import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
//import { MomentModule } from 'angular2-moment';
import * as moment from 'moment'; 

// add global variables here
import * as Constants from 'src/app/services/constants/constants';

// services used on this page
import { ApiService } from 'src/app/services/api/api.service';
import { CommonService } from 'src/app/services/common/common.service';
import { GlobalService, NavData } from 'src/app/services/global/global.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { GeolocationWrapperService } from 'src/app/services/geolocation/geolocation.service';
import { NotificationData, SiteStructure } from 'src/app/services/global/structure';
import { ThemeService } from 'src/app/services/theme/theme.service';

// components used on this page
import { MyfooterComponent } from 'src/app/components/myfooter/myfooter.component';
import { MystatusComponent } from 'src/app/components/mystatus/mystatus.component';
import { MyloadingComponent } from 'src/app/components/myloading/myloading.component';
import { MyapiinfoComponent } from 'src/app/components/myapiinfo/myapiinfo.component';
// import { MymenubadgeComponent } from 'src/app/components/mymenubadge/mymenubadge.component';
import { MygeoinfoComponent } from 'src/app/components/mygeoinfo/mygeoinfo.component';
import { MycameraComponent } from 'src/app/components/mycamera/mycamera.component';
import { ApiReturn } from 'src/app/services/api/apireturn';

//import { ViewController } from '@ionic/core';

@Component({
  selector: 'app-attention-actionable-modal',
  templateUrl: './attention-actionable-modal.page.html',
  styleUrls: ['./attention-actionable-modal.page.scss'],
})
export class AttentionActionableModalPage implements OnInit
, OnDestroy 
{
  @ViewChild(IonContent) content: IonContent;   
  @ViewChild(MyfooterComponent) myfooterComponent: MyfooterComponent;   
  @ViewChild(MystatusComponent ) mystatusComponent: MystatusComponent; 
  @ViewChild(MyloadingComponent ) myloadingComponent: MyloadingComponent; 
  @ViewChild(MyapiinfoComponent ) myapiinfoComponent: MyapiinfoComponent;
  @ViewChild(MygeoinfoComponent) mygeoinfoComponent: MygeoinfoComponent;   
  
  // ***********************************************************************************************
  public pageName:string = "AttentionActionableModal";  // *********** SPECIFIC TO MODAL ***********
  public isModal:string = "true"; // *********** SPECIFIC TO MODAL ***********
  // ***********************************************************************************************

  private consoleLog:boolean = false;
  public isPageReady:boolean = false;
  public isSending:boolean = false;
  public isNoRecordsFound:boolean = false;
  // public NavData:NavData = new NavData();
  
  public isShowAdditionalInformation:boolean = false; 
  public showEventSite:boolean = false;

  public EventSite:SiteStructure;

  // page specific stuff
  ActionableBroadcastId: number; // the ID number from the item passed in
  ActionableRecipientId: number; // determined via Broadcast lookup call
  StructuredFormId: number; // determined via Broadcast lookup call
  EventId: number; // determined via Broadcast lookup call
  EventDetails: string;  // the specific event-based details (e.g. for Actionable forms)
  FormTitle: string; // determined via Broadcast lookup call
  FormQuestion: string; // determined via Broadcast lookup call
  //StructuredResponseId: number; // selected by user
  //UserResponseText: string // entered by user
  SelectedResponseFormId: number = 0;
  public SelectedResponseInd:boolean = false;
  ResponseSelectedId: number = 0; // -- NOT the same as the StructuredResponseId -- determined via Broadcast lookup call
  BroadcastResponseStatusCode:string;
  SelectedListSurveyResponseSelectedId: number; // determined via Broadcast lookup call
  isFirstTimeDisplay:boolean = true;

  //responses = [];   // maybe use a real structure for this
  public responses: Array<Response>;
  public SelectedResponse: Response = new Response();
  EmptyResponse: Response = new Response();
  

  item: any;        // the item passed in (if any -- don't rely on it)
  //ViewModel: any;   // the view after lookup
  public apiResponse: any; // the view after lookup
  public apiReturn: ApiReturn = new ApiReturn();
  public LiveFlag:boolean;
  public PriorityFlag:boolean;
  public NotificationSourceCode:string = "";
  public toolbar_color:string = 'mytoolbar';  // default color (may change for modal use)

  record:Record = new Record();

  public MobileMediaCount:number = 0;
  public MobileMediaList: Array<{ MobileMediaId:number, MobileMediaContentUrl:string}>;

  constructor( private alertController: AlertController
    , public modalController: ModalController
    , public apiProvider: ApiService
    , private geolocationProvider: GeolocationWrapperService
    , public globalProvider: GlobalService
    , private commonProvider: CommonService
    , public zone: NgZone
    , public events: Events
    , public translate: TranslateService
    , private themeService: ThemeService
    , public router: Router
  ) 
  {  
    this.consoleLog = this.globalProvider.consoleLog_attentionactionable;
    if (this.consoleLog) console.log(this.pageName + ".ctor - LifeCycle");

    this.GetNavData();
  }

  // ----------------------------------------------------
  // ------ PAGE LIFE-CYCLE EVENTS (Angular)  -----------
  // ----------------------------------------------------
  ngOnInit()     {  if (this.consoleLog) console.log(this.pageName + ".ngOnInit - LifeCycle");     }
  ngOnDestroy () {  if (this.consoleLog) console.log(this.pageName + ".ngOnDestroy - LifeCycle");  }

  // ----------------------------------------------------
  // ------ PAGE LIFE-CYCLE EVENTS (Ionic)  -------------
  // ----------------------------------------------------
  ionViewWillEnter() 
  {
    this.consoleLog = this.globalProvider.consoleLog_attentionactionable;
    if (this.consoleLog) console.log(this.pageName + ".ionViewWillEnter - LifeCycle"); 
  }
  
  ionViewWillLeave() {  if (this.consoleLog) console.log(this.pageName + ".ionViewWillLeave - LifeCycle"); }
  
  ionViewDidEnter()   // ionViewDidLoad()
  {
    if (this.consoleLog) console.log(this.pageName + ".ionViewDidEnter - LifeCycle");
    this.SubscribeComponents(true, "AttentionActionable.ENTER");
    this.Initialize("ionViewDidEnter");
  }

  ionViewDidLeave()  
  {  
    if (this.consoleLog) console.log(this.pageName + ".ionViewDidLeave - LifeCycle"); 
    this.SubscribeComponents(false, "AttentionActionable.LEAVE");
  }

  SubscribeComponents(isSubscribe:boolean, context:string)
  {
    if (this.consoleLog) console.log(this.pageName + ".SubscribeComponents:" + isSubscribe + ' - LifeCycle');
    if (this.myfooterComponent) this.myfooterComponent.subscriptions(isSubscribe, context); 
    if (this.mystatusComponent) this.mystatusComponent.subscriptions(isSubscribe, context);
    this.geolocationProvider.setWatchDependency(Constants.WATCH_ACTIONABLE_RESPONSE, isSubscribe, "AttentionActionableModal.SubscribeComponents");
  }

  // ***********************************************************************************
  // *****                          SPECIFIC TO MODAL                            *******
  // ***********************************************************************************
  GetNavData()
  {
    if (this.isModal === "true") { this.GetNavDataModal(); }
    else                         { this.GetNavDataPage();  }
  }
  
  GetNavDataModal()
  {
    console.log(this.pageName + ".GetNavDataModal: " + this.globalProvider.NavData.ModalActionableBroadcastId, this.globalProvider.NavData);
    this.item = {};
    this.ActionableBroadcastId = this.globalProvider.NavData.ModalActionableBroadcastId;
    this.NotificationSourceCode = this.globalProvider.NavData.ModalActionableNotificationSourceCode;
    this.toolbar_color = 'actionable'; // 'warning';  
    if (this.consoleLog) console.log(this.pageName + ".GetNavDataModal - ActionableBroadcastId:" + this.ActionableBroadcastId + " Source:" + this.NotificationSourceCode, this.item);
  }

  GetNavDataPage()  // Do NOT use in MODAL screen
  {
    console.log(this.pageName + ".GetNavDataPage: " + this.globalProvider.NavData.AbstractId, this.globalProvider.NavData);
    this.item = this.globalProvider.NavData.item;
    this.ActionableBroadcastId = this.globalProvider.NavData.AbstractId;
    this.NotificationSourceCode = this.globalProvider.NavData.NotificationSourceCode; //"ATTENTION LIST";
    if (this.consoleLog) console.log(this.pageName + ".GetNavDataPage - ActionableBroadcastId:" + this.ActionableBroadcastId + " Source:" + this.NotificationSourceCode, this.item);
  }

  // ************************************************************************

  goBack()
  {
    if (this.isModal === "true") { this.goBackModal(); }
    else                       { this.goBackPage();  }
  }

  goBackModal()
  {
    console.log(this.pageName + ".goBackModal: this is MODAL so use dismiss");
    this.globalProvider.NavData.InitActionableModal(this.pageName + ".goBackModal");
    this.modalController.dismiss();  
    return;
  }

  goBackPage() // Do NOT use in MODAL screen
  {
    if (this.consoleLog) console.log(this.pageName + ".goBack: this is NOT modal - (via " + this.globalProvider.NavData.SourceUrl + ")");

    // for now go back to PARENT level since we can now go another level further down (Map, Status Update)
    // for now go back to PARENT level since we can now go another level further down (Map, Status Update)
    console.log(this.pageName + ".goBackPage - via " + this.globalProvider.NavData.ParentUrl 
              + " LiveFlag:" + this.LiveFlag
              );

    this.globalProvider.NavData.IsNavDataExists = true;
    if (!this.globalProvider.NavData.SourceUrl) // e.g. 'attention'
    {
      console.log(this.pageName + ".goBackPage to HARD-CODED: /attention");
      this.globalProvider.NavData.SourceUrl = '/attention'; // set a default in case we start here (PARENT!)
    }  
    this.globalProvider.NavData.GoBackFlag = true;  // back up a level

    console.log(this.pageName + ".goBackPage to SourceUrl:" + this.globalProvider.NavData.SourceUrl);
    this.router.navigateByUrl(this.globalProvider.NavData.SourceUrl);
  }
  // ***********************************************************************************
  // *****                          SPECIFIC TO MODAL                            *******
  // ***********************************************************************************
  


  // ----------------------------------------------------
  // --------------- COMMON SCREEN PROGRESS   -----------
  // ----------------------------------------------------

  SetApiCallInfo(apiResponse)
  {
    if ((!apiResponse) || (!apiResponse.ApiReturn)) { return; }
    this.myapiinfoComponent.SetApiReturn(apiResponse.ApiReturn); // this is for display purposes only
    this.apiReturn.SetApiReturn(apiResponse.ApiReturn); // similar to above, but we have it locally here
  }

  // ----------------------------------------------------
  // -------------------   INITIALIZE    ----------------
  // ----------------------------------------------------
  Initialize(context:string)
  {
    if (this.consoleLog) console.log(this.pageName + ".Initialize");
    moment.locale(this.globalProvider.GetActiveMomentLocale());
    this.themeService.enableTheme(Constants.THEME_INITIAL);
    this.isPageReady = false;
    
    // the loading component should be ready, but something has changed since upgrading Ionic/Angular
    if (this.myloadingComponent) this.myloadingComponent.SetPageLoading(this.pageName, 0);

    this.GetNavData();  
    this.CallRequestForActionableForm(null);
  }


  btnCancel()
  {
    console.log(this.pageName + ".btnCancel");
    //this.goBack();
    this.goBackWithValidation();
  }

  // ----------------------------------------------------
  // --------------- VALIDATE NAVIGATION ----------------
  // ----------------------------------------------------

  goBackWithValidation()
  {
    console.log(this.pageName + ".goBackWithValidation");
    if (this.record.isPendingUpdate())
    {
      console.log(this.pageName + ".goBackWithValidation: there are pending updates");
      this.AlertCancelPendingUpdate();
      return;
    }

    this.goBackModal();  // ******** SPECIFIC TO MODAL ************
    //this.goBack();     // ******** SPECIFIC TO MODAL ************
  }

  myTranslate(value:string):string
  {
    // WARNING! inline translation will CRASH if the value is empty
    if (!value) { return ""; }
    return this.translate.instant(value);
  }

  async AlertCancelPendingUpdate() 
  {
    const alert = await this.alertController.create({
      header: this.myTranslate('Pending Updates'),
      message: this.myTranslate('Are you sure you want to ignore changes?'),
      buttons: [
        {
          text: this.myTranslate('Yes'),
          //role: 'cancel',
          handler: () => {
            console.log(this.pageName + ".AlertCancelPendingUpdate - Yes, cancel changes");
            this.goBack();
          }
        },
        {
          text: this.myTranslate('No'),
          handler: () => {
            console.log(this.pageName + ".ConfirmButtonAction - No, stay on the screen");
            return;
          }
        }
      ]
    });
    await alert.present();
  }
  

  // ----------------------------------------------------
  // --------------- API FUNCTION CALLS       -----------
  // ----------------------------------------------------

  CallRequestForActionableForm(refresher)
  {
    if (this.consoleLog) console.log(this.pageName + ".CallRequestForActionableForm");

    this.isPageReady = false;
    this.isSending = true;
    this.myloadingComponent.SetPageLoading(this.pageName, 0); //  this.SetPageLoading(0); 
    this.apiProvider.RequestForActionableForm( this.ActionableBroadcastId )                          
    .then(data => { 
      this.zone.run(() => {
        if (refresher) { refresher.target.complete(); }
        this.isPageReady = true;
        this.isSending = false;
        this.myloadingComponent.SetPageLoading(this.pageName, 1); //  this.SetPageLoading(1); 
        this.SetApiCallInfo(data);
        this.PopulateFormFromApiResponse(data);
      });
     }
    , 
    errorMessage => {
      this.zone.run(() => {
        this.isPageReady = false;
        this.isSending = false;
        this.myloadingComponent.SetPageLoading(this.pageName, 9, errorMessage); //  this.SetPageLoading(9, errorMessage); 
        this.SetApiCallInfo(errorMessage);
        console.warn("error", errorMessage);
      });
    });
  }

  PopulateMediaFromApiResponse(apiResponse)
  {
    this.MobileMediaList = [];  // the onscreen display of images
    this.MobileMediaCount = apiResponse.MobileSurvey.MobileMediaCount;

    if (this.consoleLog) console.log(this.pageName + ".PopulateMediaFromApiResponse - MobileMediaCount:" + this.MobileMediaCount);
    if ((!this.MobileMediaCount) || (this.MobileMediaCount <= 0)) { return; }
    if (!apiResponse.MobileMediaList) { return; }
    if (this.consoleLog) console.log(this.pageName + ".PopulateMediaFromApiResponse - apiResponse,MobileMediaList:", apiResponse.MobileMediaList);

    this.MobileMediaList = [];  // the onscreen display of images
    this.MobileMediaCount = apiResponse.MobileMediaList.length;  // better to use this value
    for(let i = 0; i < this.MobileMediaCount; i++) 
    { 
      //console.log(this.modalText + "PopulateMediaFromApiResponse - i:" + i);
      this.MobileMediaList.push(
        { MobileMediaId: apiResponse.MobileMediaList[i].MobileMedia.MobileMediaId
        , MobileMediaContentUrl: this.apiProvider.GetMediaContent(apiResponse.MobileMediaList[i].MobileMedia.MobileMediaId)
        }
      );
// tslint:disable-next-line: max-line-length
      //, MobileMediaContentUrl: "https://ambit.maxxess-systems.com/AmbitMobileApiCORS/api/mobile/image/GetMediaContent?Client=App&MobileMediaId=1196&MobileSendGuid=65dce385-0240-483f-ae16-6298cca9429d&MobileDeviceGuid=fbeaf255-d3e7-4ec0-a1ff-46491f0021a7&OrganizationId=0&OrganizationCode=ORG_PENDING&MobileDatetime=2018-07-28T11:56:12&MobileDatetimeUtc=2018-07-28T18:56:12Z&MobileAppTypeCode=BROWSER&MobileAppVersionCode=5.06.1805200&ApiServiceEnvironment=TEST&AmbitMobileAppRunContext=unknown&DeviceCarrierCode=unknown&DeviceTypeCode=unknown&DevicePlatformCode=unknown&DeviceBrandCode=unknown&DeviceProductCode=unknown&DeviceOsVersionCode=unknown&NativeDeviceUuid=unknown&GpsProvidedFlag=TRUE&GpsFormatCode=DECIMAL&GpsLatitude=33.7165657&GpsLongitude=-117.75415210000001&GpsFloor=null&GpsAccuracyMeters=35&PositionType=GPS&GpsAltitude=null&GpsPositionChangedCounter=1&GpsMobileDatetime=2018-07-28T11:56:09&GpsTimestamp=1532804169771"
    }

    if (this.consoleLog) console.log(this.pageName + ".PopulateMediaFromApiResponse - this.MobileMediaList:", this.MobileMediaList);
  }

  PopulateFormFromApiResponse(apiResponse)
  {
    if (this.consoleLog) console.log(this.pageName + ".PopulateFormFromApiResponse");

    //this.ViewModel = apiResponse.ViewModel; // Newer approach -- not implemented everywhere yet
    this.apiResponse = apiResponse; // WE SHOULD USE ViewModel LATER --> this.ViewModel = apiResponse.ViewModel;
    this.PopulateActionableFromApiResponse(apiResponse.MobileSurvey, apiResponse.StructuredForm, apiResponse.Event);
    this.PopulateMediaFromApiResponse(apiResponse);

    // ToDo: we should return the LiveFlag in the MobileSurvey structure
    //this.LiveFlag = apiResponse.MobileSurvey.LiveFlag;
  }

  PopulateActionableFromApiResponse(MobileSurvey:any, StructuredForm:any, Event:any)
  {
    console.log(this.pageName + ".PopulateActionableFromApiResponse");

    if (!MobileSurvey.SurveyBroadcastId)
    {
      console.warn(this.pageName + ".PopulateActionableFromApiResponse - NO ACTIONABLE FORM FOUND!");
      this.isPageReady = false;
      return;
    }
    
    this.EventId = this.commonProvider.GetNumber(Event.EventId, 0);
    this.ActionableBroadcastId = MobileSurvey.SurveyBroadcastId;
    this.ActionableRecipientId = MobileSurvey.SurveyRecipientId;
    this.LiveFlag = MobileSurvey.LiveFlag;
    this.PriorityFlag = MobileSurvey.PriorityFlag;
    this.StructuredFormId = StructuredForm.StructuredFormId;
    //this.StructuredResponseId = 0; // This is selected by User
    //this.UserResponseText = ""; // this is entered by user
    //this.ApiRequestOrStorage = "";  // use blank for API

    this.SetEventDetailsAndFormQuestion(StructuredForm.MessageText);
    this.FormTitle = this.commonProvider.GetValue(StructuredForm.MessageTitleText,"ATTENTION");

    // these are all string delimited values
    let ResponseListStructuredResponseFormId = this.commonProvider.GetValue(StructuredForm.ResponseListStructuredResponseFormId,"");  // 588|589|590|591|592
    let ResponseListResponseText = this.commonProvider.GetValue(StructuredForm.ResponseListResponseText,"");
    
    // we only support a single selection from a list right now, so assume only one value is present
    this.SelectedResponseFormId // = apiResponse.MobileSurvey.SelectedListSurveyResponseFormId;
    = this.commonProvider.GetNumber(MobileSurvey.SelectedListSurveyResponseFormId, 0, "SelectedResponseFormId");
    console.log(this.pageName + ".PopulateActionableFromApiResponse - API - SelectedResponseFormId:" + this.SelectedResponseFormId);
      
    this.ResponseSelectedId 
    = this.commonProvider.GetNumber(MobileSurvey.SelectedListSurveyResponseSelectedId, 0, "ResponseSelectedId");
    console.log(this.pageName + ".PopulateActionableFromApiResponse - API - ResponseSelectedId:" + this.ResponseSelectedId);
    
    this.SelectedResponseInd = this.commonProvider.GetBoolean(MobileSurvey.SelectedResponseInd, false);
    console.log(this.pageName + ".PopulateActionableFromApiResponse - API - SelectedResponseInd:" + this.SelectedResponseInd);
    
    // special handling for previous response to the survey (if any)
    /*
    if (this.SelectedResponseInd === true)
    {
      var SelectedListSurveyResponseFormId = MobileSurvey.SelectedListSurveyResponseFormId;
      var SelectedListSurveyResponseSelectedId = MobileSurvey.SelectedListSurveyResponseSelectedId;
      var SelectedListUserResponseText = MobileSurvey.SelectedListUserResponseText;
      CheckForPreviousResponse(SelectedResponseInd, SelectedListSurveyResponseSelectedId, SelectedListSurveyResponseFormId, arrayResponseId, arrayResponseText, SelectedListUserResponseText);
    }
    */

    // start off with the default that NO RESPONSE has been selected -- then check the array to see if any have been selected already
    this.SelectedResponse = this.EmptyResponse;

    // break up the string delimited values into an array
    let arrayResponseId = ResponseListStructuredResponseFormId.split('|');
    let arrayResponseText = ResponseListResponseText.split('|'); 
    
    // Override ResponseChoiceCount with the actual array (since some may be disabled)
    let ResponseChoiceCount = 0;
    if (arrayResponseText) 
    { 
      ResponseChoiceCount = arrayResponseText.length; 
    }

    // No records found
    if (ResponseChoiceCount === 0)
    {
      if (this.consoleLog) console.warn(this.pageName + ".PopulateActionableFromApiResponse - no ResponseChoiceCount");
      this.isNoRecordsFound = true;
      this.responses = [];
      return;
    }

    // records found
    if (this.consoleLog) console.log(this.pageName + ".PopulateActionableFromApiResponse - loop through ResponseChoiceCount:" + ResponseChoiceCount);
    this.isNoRecordsFound = false;
    this.responses = [];
    for(let i = 0; i < ResponseChoiceCount; i++)   // for (index in arrayResponseId)
    {
      let response:Response = new Response();
      response.ResponseFormId = this.commonProvider.GetNumber(arrayResponseId[i], 0, "arrayResponseId[" + i + "]");
      response.ResponseText = arrayResponseText[i];
      response.isSelected = (this.SelectedResponseFormId === response.ResponseFormId)? true : false;
      this.responses.push(response); // add to the array of possible options

      if (response.isSelected)
      {
        this.SelectedResponse = response;
        this.SelectedResponse.isSelected = true;
        this.record.setResponseId(response.ResponseFormId); // this.SelectedResponseFormId);
        this.record.setUserResponseText(MobileSurvey.SelectedListUserResponseText); 
        this.record.Update.ResponseFormId = response.ResponseFormId;
        this.record.Update.UserResponseText = MobileSurvey.SelectedListUserResponseText;
        // these values should all be the same
        console.log(this.pageName + ".PopulateActionableFromApiResponse - loop[" + i + "] PREVIOUSLY SELECTED -" 
        + " ResponseFormId:" + response.ResponseFormId + " ResponseSelectedId:" + this.ResponseSelectedId + " SelectedResponseFormId:" + this.SelectedResponseFormId
        , response);
      } 
    }

    this.BroadcastResponseStatusCode = this.GetBroadcastResponseStatusCode(this.SelectedResponseInd); // set the response code and determine if this is the latest survey we are viewing
    this.globalProvider.SetStorageObject_LatestActionableForm(this.ActionableBroadcastId, this.ActionableRecipientId, this.BroadcastResponseStatusCode);
  
    // we expect these two values to be the same -- one comes from the API server call and the other is programmatically determined
    // - this is more for debugging logic purposes
    if (this.SelectedResponse.isSelected !== this.SelectedResponseInd)
    {
      console.warn(this.pageName + ".PopulateActionableFromApiResponse - MISMATCH - " 
      + " SelectedResponse.isSelected(code):" + this.SelectedResponse.isSelected + " != "
      + " SelectedResponseInd(api):" + this.SelectedResponseInd);
    }
    
    if ((this.SelectedResponseInd === true) && (this.LiveFlag===true))
    {
      console.log(this.pageName + ".PopulateActionableFromApiResponse - display AlertAlreadyResponded");
      // this.AlertAlreadyResponded();  // this is now displayed directly on the page
    }
  }
  
  SetEventDetailsAndFormQuestion(MessageText:string)
  {
    console.log(this.pageName + ".SetEventDetailsAndFormQuestion: " + MessageText);

    if (!MessageText)
    {
      this.EventDetails = "";
      this.FormQuestion = "Select from the following";
    }

    if (MessageText.includes("|"))
    {
      let arrayMessageText = MessageText.split('|'); 
      if (arrayMessageText.length === 2)
      {
        this.EventDetails = arrayMessageText[0];
        this.FormQuestion = arrayMessageText[1];
      }
      else
      {
        this.EventDetails = "";
        this.FormQuestion = MessageText;
      }
    }
    else
    {
      this.EventDetails = "";
      this.FormQuestion = MessageText;
    }
  }

  btnResponseSelected(response) 
  {
    console.log(this.pageName + " responseSelected " + response.ResponseFormId, response);
    this.record.Update.ResponseFormId = response.ResponseFormId;
    this.SelectedResponse = response;
    this.SelectedResponse.isSelected = true;
    this.isFirstTimeDisplay = false;
    this.ChangeResponsesView();
  }

  btnResponseDeselected(response) 
  {
    console.log(this.pageName + " responseDeselected " + response.ResponseFormId, response);
    this.record.Update.ResponseFormId = 0;
    this.SelectedResponse = this.EmptyResponse;
    this.SelectedResponse.isSelected = false;
    this.isFirstTimeDisplay = false;
    this.ChangeResponsesView();
  }

  ChangeResponsesView()
  {
    for (let i = 0; i < this.responses.length; i++)   // for (index in arrayResponseId)
    {
      if (this.responses[i].ResponseFormId === this.SelectedResponse.ResponseFormId)
      {
        this.responses[i].isSelected = true;
      }
      else
      {
        this.responses[i].isSelected = false;
      }
    } 
  }


  async AlertAlreadyResponded() 
  {
    const alert = await this.alertController.create({
        header: this.myTranslate('Already Responded')
      , subHeader: this.myTranslate('ID') + " " + this.ResponseSelectedId
      , message: this.myTranslate('You may change your previous answer')
      , buttons: [
        {
          text: this.myTranslate('OK'),
          handler: () => {
            console.log(this.pageName + ".AlertAlreadyResponded - OK");
            return;
          }
        }
      ]
    });
    await alert.present();
  }

  // ----------------------------------------------------
  // ----------RESPONSE API FUNCTION CALL     -----------
  // ----------------------------------------------------

  CallResponseToActionableForm() // refresher
  {
    if (this.consoleLog) console.log(this.pageName + ".CallResponseToActionableForm", this.record);

    this.isPageReady = false;
    this.myloadingComponent.SetPageLoading(this.pageName, 0); //  this.SetPageLoading(0); 
    this.apiProvider.ResponseToActionableForm
      ( this.ActionableBroadcastId
      , this.ActionableRecipientId
      , this.record.Update.ResponseFormId
      , this.record.Update.UserResponseText
      )
    .then(data => { 
      this.zone.run(() => {
        //if (refresher) { refresher.target.complete(); }
        this.isPageReady = true;
        this.myloadingComponent.SetPageLoading(this.pageName, 1); //  this.SetPageLoading(1); 
        this.SetApiCallInfo(data);

        this.BroadcastResponseStatusCode = this.GetBroadcastResponseStatusCode(true);
        this.globalProvider.SetStorageObject_LatestActionableForm(this.ActionableBroadcastId, this.ActionableRecipientId, this.BroadcastResponseStatusCode);
  
        this.commonProvider.presentToastStick('Action completed and closed', this.apiReturn.ApiLogId);
        this.goBack();
      });
     }
    , 
    errorMessage => {
      this.zone.run(() => {
        this.isPageReady = false;
        this.myloadingComponent.SetPageLoading(this.pageName, 9, errorMessage); //  this.SetPageLoading(9, errorMessage); 
        this.SetApiCallInfo(errorMessage);
        console.warn("error", errorMessage);
      });
    });
  }

  public GetBroadcastResponseStatusCode(SelectedResponseInd:boolean)
  {
      // assumption is it is no longer PENDING since they are viewing it
      if (SelectedResponseInd === true)
      {
        return "RESPONDED";
      }
      else
      {
        return "RECEIVED";
      }
  }

  public btnAlreadyClosed()
  {
    if (this.consoleLog) console.log(this.pageName + ".btnAlreadyClosed");
    this.AlertAlreadyClosed();
  }

  async AlertAlreadyClosed()
  {  
    if (this.consoleLog) console.log(this.pageName + ".AlertAlreadyClosed");

    const alert = await this.alertController.create({
      header: this.myTranslate('Closed'),
      message: this.myTranslate('This form is no longer live'),
      buttons: [
        {
          text: this.myTranslate('OK'),
          handler: () => {
            console.log(this.pageName + ".AlertAlreadyClosed - Confirm close");
          }
        }
      ]
    });
    await alert.present();
  }

  // ----------------------------------------------------
  // ----------    ACTION RESPONSE BUTTON     -----------
  // ----------------------------------------------------

  public btnSend()
  {
    console.log(this.pageName + ".btnSend");

    // record.Update.UserResponseText
    //console.log(this.modalText + "AttentionActionable.btnSend - UserResponseText: " + this.UserResponseText);
    //this.UserResponseText = this.Model.UserResponseText;

    if (!this.ValidateSendFormResponse())
    {
      this.AlertValidationError();
      return;
    }
    
    this.CallResponseToActionableForm();
  }

  ValidateSendFormResponse():boolean
  {
    if (this.record.Update.ResponseFormId === 0)
    {
      return false;
    }
    return true;
  }

  async AlertValidationError() 
  {
    const alert = await this.alertController.create({
      header: this.myTranslate('Validation Error'),
      message: this.myTranslate('Please select an option'),
      buttons: [
        {
          text: this.myTranslate('OK'),
          handler: () => {
            console.log(this.pageName + ".AlertValidationError - OK");
            return;
          }
        }
      ]
    });
    await alert.present();
  }
  
  public receiveEventSite(eventSite:SiteStructure)
  {
    if (this.consoleLog) console.log("receiveEventSite", eventSite);
    this.zone.run(() => {
      if (!eventSite)
      {
        this.EventSite = null;
      }
      else
      {
        this.EventSite = eventSite;
      }
      //this.SetDivElementDisplay();
    });
  }
  
  public GetIndex(zeroIndex):number
  {
    return Number(zeroIndex + 1); //.toString(); // return zeroIndex + 1;
  }
}

@Injectable()
export class Record 
{
  consoleLog:boolean = false;

  // values that can be updated
  Original: DataSet = new DataSet();
  Update: DataSet = new DataSet();

  constructor() { if (this.consoleLog) console.log('Record.ctor - LifeCycle'); }

  set( ResponseFormId: number
     , UserResponseText: string )
  {
    console.log("set - ResponseFormId:" + ResponseFormId + " StatusText:" + UserResponseText);

    this.Original.ResponseFormId = ResponseFormId;
    this.Update.ResponseFormId = ResponseFormId;

    this.Original.UserResponseText = UserResponseText;
    this.Update.UserResponseText = UserResponseText;
  }

  setResponseId(ResponseFormId: number)
  {
    this.Original.ResponseFormId = ResponseFormId;
    this.Update.ResponseFormId = ResponseFormId;
  }

  setUserResponseText(UserResponseText: string)
  {
    this.Original.UserResponseText = UserResponseText;
    this.Update.UserResponseText = UserResponseText;
  }

  isPendingUpdate():boolean
  {
    console.log("isPendingUpdate: Original", this.Original);
    console.log("isPendingUpdate: Update", this.Update);

    if (this.Original.ResponseFormId !== this.Update.ResponseFormId) { return true; } // live flag changed
    if (this.Original.UserResponseText !== this.Update.UserResponseText)  { return true; } // new status text entered
    return false;
  }
}

@Injectable()
export class DataSet 
{
  consoleLog:boolean = false;

  // values that can be updated
  ResponseFormId: number;
  UserResponseText: string;

  constructor() { if (this.consoleLog) console.log('DataSet.ctor - LifeCycle'); }
}

@Injectable()
export class Response 
{
  consoleLog:boolean = false;

  // this is just a structure for the responses the user can select from
  ResponseFormId: number = 0;
  ResponseText: string = ""; 
  isSelected:boolean = false;

  constructor() { if (this.consoleLog) console.log('Response.ctor - LifeCycle'); }
}

